import React from 'react';

/**
 * Pastille de score réutilisable (onglets SEO et Performance).
 *
 * Les seuils sont paramétrables pour conserver les nuances historiques de chaque
 * onglet (SEO affiche un % ; Performance un score brut sur 100).
 */
export default function ScorePill({
  value,
  suffix = '%',
  warnBelow = 90,
  dangerBelow = 60,
  perfectAt = 100,
  hideZero = false,
  minWidthClass = 'min-w-[40px]',
}) {
  const n = Math.round(Number(value) || 0);
  if (hideZero && !n) return null;

  let bg = 'bg-green-100 text-green-700';
  if (n < warnBelow) bg = 'bg-amber-100 text-amber-700';
  if (n < dangerBelow) bg = 'bg-red-100 text-red-700';
  if (n >= perfectAt) bg = 'bg-green-500 text-white font-semibold';

  return (
    <span className={`inline-flex items-center justify-center ${minWidthClass} px-2 py-0.5 rounded-md text-sm font-medium ${bg}`}>
      {n}{suffix}
    </span>
  );
}
